import { Breadcrumb } from 'antd';
import { useLocation } from 'react-router-dom';

const NaviBreadcrumb = () => {
    const location = useLocation();
    const pathnames = location.pathname.split('/').filter((x) => x);
    const { from } = location.state || { from: "home" };

    var items = [];
    items.push({
        title:
            <span>Home</span>
    });

    if (Array.isArray(pathnames) && pathnames.length > 0) {
        switch (pathnames[0].toLowerCase()) {
            case 'shamelist':
                items.push({
                    title:
                        <span>Hall of Shame</span>
                });
                break;
            case 'search':
                items.push({
                    title:
                        <span>Search results</span>
                });
                break;
            case 'detail':
                if (from === 'search') {
                    items.push({
                        title:
                            <span>Search results</span>
                    },
                        {
                            title:
                                <span>Premise detail</span>
                        });
                } else if (from === 'shameList') {
                    items.push({
                        title:
                            <span>Hall of Shame</span>
                    },
                        {
                            title:
                                <span>Premise detail</span>
                        });
                }
                else {
                    items.push({
                        title:
                            <span>Premise detail</span>
                    });
                }
                break;
            default:
                items.push({
                    title:
                        <span>About</span>
                });
                break;
        }
    }

    return (
        <Breadcrumb
            style={{
                margin: '16px 0',
            }}
            items={items} />
    );
};

export default NaviBreadcrumb